import { render } from "./BoardDetail.vue?vue&type=template&id=b87027f0"
import script from "./BoardDetail.vue?vue&type=script&lang=js"
export * from "./BoardDetail.vue?vue&type=script&lang=js"
script.render = render

export default script